<body class="wrapper-grid">
    <app-header></app-header>
    <app-side-nav></app-side-nav>
    <app-breadcrumb  [ngClass]="{'bread-crumb-content-hide': hideBreadCrumbs === true}"  *ngIf="!isMobile" id="breadcrumb" class="breadcrumbs-content"></app-breadcrumb>
    <div class="content"  [ngClass]="{'content-reduce-margin': hideBreadCrumbs === true}"> 
      <app-sub-breadcrumb [ngClass]="{'bread-crumb-content-hide': hideBreadCrumbs === true}" *ngIf="isMobile"></app-sub-breadcrumb>
        <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </body>